import axios from "axios"

export default {
	namespaced: true,
	state: {
		breadcrumb: [],
		users: undefined
	},
	getters: {
		breadcrumb: state => state.breadcrumb,
		users: state => state.users
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		},
		getList({ commit }, filters) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/all",
					{ filters },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { value: res.data, element: "users" })
				})
				.catch(err => {
					console.error(err)
				})
		},
		async handleDelete({ state, commit }, array) {
			var r = false
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/batchDelete",
					{ array },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					for (var i = 0; i < state.users.array.length; i++) {
						if (res.data.deleted && res.data.deleted.includes(state.users.array[i].id))
							state.users.array[i].deleted_at = new Date()
					}

					r = true
				})
				.catch(err => {
					console.error(err)
					r = err.response.data.Message
				})
			return r
		},
		async handleRestore({ state, commit }, array) {
			var r = false
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/batchRestore",
					{ array },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					for (var i = 0; i < state.users.array.length; i++) {
						if (res.data.restored && res.data.restored.includes(state.users.array[i].id))
							state.users.array[i].deleted_at = undefined
					}
					r = true
				})
				.catch(err => {
					r = err.response.data.Message
					console.error(err)
				})

			return r
		}
	}
}
